<template>
	<div>
		<SortableList v-if="value.length" :value="value" @input="update" keyProp="name">
			<div class="prize" v-for="prize of value" :key="prize.name">
				<PrizeImage :url="prize.url" />
				<p class="name">{{ prize.name }}</p>
			</div>
		</SortableList>
		<p class="empty" v-else>Add a prize below.</p>
		<hr />
		<AddPrizeForm :prizes="value" @add="onAdd" />
	</div>
</template>

<script>
import SortableList from '@/components/SortableList'
import PrizeImage from '@/components/PrizeImage'
import AddPrizeForm from '@/forms/AddPrizeForm'

export default {
	name: 'PrizesForm',
	props: {
		value: Array,
	},
	methods: {
		update(value) {
			this.$emit('input', value)
		},
		onAdd(prize) {
			this.$emit('input', [...this.value, prize])
		},
	},
	components: {
		SortableList,
		PrizeImage,
		AddPrizeForm,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/layout';

.prize {
	@extend %flex-row;
	padding: 0.5rem;

	@include not-last {
		margin-right: 1rem;
	}

	.name {
		flex-grow: 1;
		text-transform: uppercase;
		font-size: 1.5rem;
		font-weight: bold;
		margin: 0;
	}
}
</style>
